import React, {useContext} from 'react';
import LangContext from '../../context/LangContext';
import {Typography} from '@material-ui/core/';
import handPic from './Material/Hand.png';


export const Maindescription = (props) => {
  const [lang] = useContext(LangContext);
  return <>
    {lang==="se" ? <>
      <Typography variant="h6" gutterBottom>
        Smedsby centrum
      </Typography>
      <br/>

      Detta är en interaktiv presentation av Smedsby centrum.<br/><br/>

      <Typography variant="h6" gutterBottom>
      Interaktivt innehåll
      </Typography>
      <img style={{width: 150}} src={handPic} alt="Hand" />
      <br/><br/>
      Innehållet är interaktivt, du kan röra dig fritt omkring eller välja någon av de kategorierna nedan. Med pilarna kan du stega igenom allt innehåll.
      <br/><br/>
      </> : <>
      <Typography variant="h6" gutterBottom>
        Sepänkylän keskusta
      </Typography>
      <br/>

      Tämä on interaktiivinen esittely Sepänkylän keskustasta.<br/><br/>

      <Typography variant="h6" gutterBottom>
      Interaktiivista sisältöä
      </Typography>
      <img style={{width: 150}} src={handPic} alt="Hand" />
      <br/><br/>
      Sisältö on interaktiivista, voit vapaasti liikuttaa näkymää tai valita näkymän alhaalta. Nuolilla voit selata näkymät läpi järjestyksessä.
      <br/><br/>
    </>}
  </>
};

export default Maindescription;